import {gql} from 'apollo-angular';

export const CustomerProfileFragment = gql`
  fragment CustomerProfileFragment on CustomerProfile {
    id
    vismaId
    fullName
    emailForOrderConfirmation
    phoneNumber
    accountType
    companyName
    cvr
    ean
    hasPassword
    defaultBillingAddress {
      id
      address
      addressCity
      addressZip
      countryCode
    }
  }
`;
